import { render, staticRenderFns } from "./homeText.vue?vue&type=template&id=5c50c5af"
import script from "./homeText.vue?vue&type=script&lang=js"
export * from "./homeText.vue?vue&type=script&lang=js"
import style0 from "./homeText.vue?vue&type=style&index=0&id=5c50c5af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports